import { Children } from "react";

const PickInput = ({id, inputType= 'checkbox', name, children }) => {
    const peerChecked =
    "peer-checked:border-[#dc7143] peer-checked:border-[10px] peer-checked:before:opacity-100 before:border-white before:opacity-0 before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:border-0 before:border-b-2 before:border-r-2 before:border-white before:rotate-45 before:h-[10px] before:w-[5px] before:transition-all before:duration-500 before:delay-150";
  return (
    <label htmlFor={id} className="flex items-center cursor-pointer">
      <input type={inputType} id={id} className="peer hidden" name={name}/>
      <span
        className={`checked inline-block h-5 w-5 border-2 ${inputType === 'checkbox'? 'rounded': 'rounded-full'} border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
      ></span>
      <span>{children}</span>
    </label>
  );
};


export default PickInput;